import "../../index92.css";
import { jsx as ve, jsxs as Nt, Fragment as Dt } from "react/jsx-runtime";
import * as O from "react";
import te, { useState as we, createContext as Wt, forwardRef as jt, useRef as Oe, useCallback as ae, useEffect as Ne, useMemo as $t, Fragment as Bt, PureComponent as zt } from "react";
import { CloseFillIcon as qt } from "@ifrc-go/icons";
import { _ as $e } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import Yt from "../Button/index.js";
import Ut from "../Container/index.js";
import Vt from "../Portal/index.js";
import Ht from "../../hooks/useTranslation.js";
import { g as Gt } from "../../_commonjsHelpers-BkfeUUK-.js";
var q = function() {
  return q = Object.assign || function(r) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      t = arguments[n];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (r[a] = t[a]);
    }
    return r;
  }, q.apply(this, arguments);
};
function De(e, r) {
  var t = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      r.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (t[n[o]] = e[n[o]]);
  return t;
}
function Xt() {
  for (var e = 0, r = 0, t = arguments.length; r < t; r++) e += arguments[r].length;
  for (var n = Array(e), o = 0, r = 0; r < t; r++)
    for (var a = arguments[r], u = 0, i = a.length; u < i; u++, o++)
      n[o] = a[u];
  return n;
}
function Zt(e, r, t) {
  if (t || arguments.length === 2) for (var n = 0, o = r.length, a; n < o; n++)
    (a || !(n in r)) && (a || (a = Array.prototype.slice.call(r, 0, n)), a[n] = r[n]);
  return e.concat(a || Array.prototype.slice.call(r));
}
var Me = "right-scroll-bar-position", Le = "width-before-scroll-bar", Kt = "with-scroll-bars-hidden", Jt = "--removed-body-scroll-bar-size";
function Be(e, r) {
  return typeof e == "function" ? e(r) : e && (e.current = r), e;
}
function Qt(e, r) {
  var t = we(function() {
    return {
      // value
      value: e,
      // last callback
      callback: r,
      // "memoized" public interface
      facade: {
        get current() {
          return t.value;
        },
        set current(n) {
          var o = t.value;
          o !== n && (t.value = n, t.callback(n, o));
        }
      }
    };
  })[0];
  return t.callback = r, t.facade;
}
var en = typeof window < "u" ? O.useLayoutEffect : O.useEffect, Pr = /* @__PURE__ */ new WeakMap();
function Gr(e, r) {
  var t = Qt(null, function(n) {
    return e.forEach(function(o) {
      return Be(o, n);
    });
  });
  return en(function() {
    var n = Pr.get(t);
    if (n) {
      var o = new Set(n), a = new Set(e), u = t.current;
      o.forEach(function(i) {
        a.has(i) || Be(i, null);
      }), a.forEach(function(i) {
        o.has(i) || Be(i, u);
      });
    }
    Pr.set(t, e);
  }, [e]), t;
}
function Xr(e) {
  return e;
}
function Zr(e, r) {
  r === void 0 && (r = Xr);
  var t = [], n = !1, o = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return t.length ? t[t.length - 1] : e;
    },
    useMedium: function(a) {
      var u = r(a, n);
      return t.push(u), function() {
        t = t.filter(function(i) {
          return i !== u;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (n = !0; t.length; ) {
        var u = t;
        t = [], u.forEach(a);
      }
      t = {
        push: function(i) {
          return a(i);
        },
        filter: function() {
          return t;
        }
      };
    },
    assignMedium: function(a) {
      n = !0;
      var u = [];
      if (t.length) {
        var i = t;
        t = [], i.forEach(a), u = t;
      }
      var b = function() {
        var m = u;
        u = [], m.forEach(a);
      }, d = function() {
        return Promise.resolve().then(b);
      };
      d(), t = {
        push: function(m) {
          u.push(m), d();
        },
        filter: function(m) {
          return u = u.filter(m), t;
        }
      };
    }
  };
  return o;
}
function cr(e, r) {
  return r === void 0 && (r = Xr), Zr(e, r);
}
function sr(e) {
  e === void 0 && (e = {});
  var r = Zr(null);
  return r.options = q({ async: !0, ssr: !1 }, e), r;
}
var Kr = function(e) {
  var r = e.sideCar, t = De(e, ["sideCar"]);
  if (!r)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = r.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return O.createElement(n, q({}, t));
};
Kr.isSideCarExport = !0;
function fr(e, r) {
  return e.useMedium(r), Kr;
}
var Jr = sr(), ze = function() {
}, lr = O.forwardRef(function(e, r) {
  var t = O.useRef(null), n = O.useState({
    onScrollCapture: ze,
    onWheelCapture: ze,
    onTouchMoveCapture: ze
  }), o = n[0], a = n[1], u = e.forwardProps, i = e.children, b = e.className, d = e.removeScrollBar, m = e.enabled, s = e.shards, v = e.sideCar, g = e.noIsolation, S = e.inert, c = e.allowPinchZoom, y = e.as, p = y === void 0 ? "div" : y, C = e.gapMode, w = De(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), T = v, f = Gr([t, r]), W = q(q({}, w), o);
  return O.createElement(
    O.Fragment,
    null,
    m && O.createElement(T, { sideCar: Jr, removeScrollBar: d, shards: s, noIsolation: g, inert: S, setCallbacks: a, allowPinchZoom: !!c, lockRef: t, gapMode: C }),
    u ? O.cloneElement(O.Children.only(i), q(q({}, W), { ref: f })) : O.createElement(p, q({}, W, { className: b, ref: f }), i)
  );
});
lr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
lr.classNames = {
  fullWidth: Le,
  zeroRight: Me
};
function We() {
  return We = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) ({}).hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, We.apply(null, arguments);
}
var rr = { exports: {} }, Re = { exports: {} }, L = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xr;
function rn() {
  if (xr) return L;
  xr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, b = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, s = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, c = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, p = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
  function w(f) {
    if (typeof f == "object" && f !== null) {
      var W = f.$$typeof;
      switch (W) {
        case r:
          switch (f = f.type, f) {
            case b:
            case d:
            case n:
            case a:
            case o:
            case s:
              return f;
            default:
              switch (f = f && f.$$typeof, f) {
                case i:
                case m:
                case S:
                case g:
                case u:
                  return f;
                default:
                  return W;
              }
          }
        case t:
          return W;
      }
    }
  }
  function T(f) {
    return w(f) === d;
  }
  return L.AsyncMode = b, L.ConcurrentMode = d, L.ContextConsumer = i, L.ContextProvider = u, L.Element = r, L.ForwardRef = m, L.Fragment = n, L.Lazy = S, L.Memo = g, L.Portal = t, L.Profiler = a, L.StrictMode = o, L.Suspense = s, L.isAsyncMode = function(f) {
    return T(f) || w(f) === b;
  }, L.isConcurrentMode = T, L.isContextConsumer = function(f) {
    return w(f) === i;
  }, L.isContextProvider = function(f) {
    return w(f) === u;
  }, L.isElement = function(f) {
    return typeof f == "object" && f !== null && f.$$typeof === r;
  }, L.isForwardRef = function(f) {
    return w(f) === m;
  }, L.isFragment = function(f) {
    return w(f) === n;
  }, L.isLazy = function(f) {
    return w(f) === S;
  }, L.isMemo = function(f) {
    return w(f) === g;
  }, L.isPortal = function(f) {
    return w(f) === t;
  }, L.isProfiler = function(f) {
    return w(f) === a;
  }, L.isStrictMode = function(f) {
    return w(f) === o;
  }, L.isSuspense = function(f) {
    return w(f) === s;
  }, L.isValidElementType = function(f) {
    return typeof f == "string" || typeof f == "function" || f === n || f === d || f === a || f === o || f === s || f === v || typeof f == "object" && f !== null && (f.$$typeof === S || f.$$typeof === g || f.$$typeof === u || f.$$typeof === i || f.$$typeof === m || f.$$typeof === y || f.$$typeof === p || f.$$typeof === C || f.$$typeof === c);
  }, L.typeOf = w, L;
}
var N = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _r;
function tn() {
  return _r || (_r = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, b = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, m = e ? Symbol.for("react.forward_ref") : 60112, s = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, g = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, c = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, p = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
    function w(h) {
      return typeof h == "string" || typeof h == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      h === n || h === d || h === a || h === o || h === s || h === v || typeof h == "object" && h !== null && (h.$$typeof === S || h.$$typeof === g || h.$$typeof === u || h.$$typeof === i || h.$$typeof === m || h.$$typeof === y || h.$$typeof === p || h.$$typeof === C || h.$$typeof === c);
    }
    function T(h) {
      if (typeof h == "object" && h !== null) {
        var U = h.$$typeof;
        switch (U) {
          case r:
            var fe = h.type;
            switch (fe) {
              case b:
              case d:
              case n:
              case a:
              case o:
              case s:
                return fe;
              default:
                var _e = fe && fe.$$typeof;
                switch (_e) {
                  case i:
                  case m:
                  case S:
                  case g:
                  case u:
                    return _e;
                  default:
                    return U;
                }
            }
          case t:
            return U;
        }
      }
    }
    var f = b, W = d, j = i, B = u, G = r, ne = m, Q = n, ee = S, Z = g, V = t, re = a, Y = o, K = s, ce = !1;
    function se(h) {
      return ce || (ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), l(h) || T(h) === b;
    }
    function l(h) {
      return T(h) === d;
    }
    function E(h) {
      return T(h) === i;
    }
    function _(h) {
      return T(h) === u;
    }
    function x(h) {
      return typeof h == "object" && h !== null && h.$$typeof === r;
    }
    function P(h) {
      return T(h) === m;
    }
    function A(h) {
      return T(h) === n;
    }
    function R(h) {
      return T(h) === S;
    }
    function F(h) {
      return T(h) === g;
    }
    function I(h) {
      return T(h) === t;
    }
    function M(h) {
      return T(h) === a;
    }
    function k(h) {
      return T(h) === o;
    }
    function $(h) {
      return T(h) === s;
    }
    N.AsyncMode = f, N.ConcurrentMode = W, N.ContextConsumer = j, N.ContextProvider = B, N.Element = G, N.ForwardRef = ne, N.Fragment = Q, N.Lazy = ee, N.Memo = Z, N.Portal = V, N.Profiler = re, N.StrictMode = Y, N.Suspense = K, N.isAsyncMode = se, N.isConcurrentMode = l, N.isContextConsumer = E, N.isContextProvider = _, N.isElement = x, N.isForwardRef = P, N.isFragment = A, N.isLazy = R, N.isMemo = F, N.isPortal = I, N.isProfiler = M, N.isStrictMode = k, N.isSuspense = $, N.isValidElementType = w, N.typeOf = T;
  }()), N;
}
var Rr;
function Qr() {
  return Rr || (Rr = 1, process.env.NODE_ENV === "production" ? Re.exports = rn() : Re.exports = tn()), Re.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var qe, Fr;
function nn() {
  if (Fr) return qe;
  Fr = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var u = {}, i = 0; i < 10; i++)
        u["_" + String.fromCharCode(i)] = i;
      var b = Object.getOwnPropertyNames(u).map(function(m) {
        return u[m];
      });
      if (b.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(m) {
        d[m] = m;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return qe = o() ? Object.assign : function(a, u) {
    for (var i, b = n(a), d, m = 1; m < arguments.length; m++) {
      i = Object(arguments[m]);
      for (var s in i)
        r.call(i, s) && (b[s] = i[s]);
      if (e) {
        d = e(i);
        for (var v = 0; v < d.length; v++)
          t.call(i, d[v]) && (b[d[v]] = i[d[v]]);
      }
    }
    return b;
  }, qe;
}
var Ye, Ar;
function dr() {
  if (Ar) return Ye;
  Ar = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ye = e, Ye;
}
var Ue, Ir;
function et() {
  return Ir || (Ir = 1, Ue = Function.call.bind(Object.prototype.hasOwnProperty)), Ue;
}
var Ve, kr;
function on() {
  if (kr) return Ve;
  kr = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = dr(), t = {}, n = et();
    e = function(a) {
      var u = "Warning: " + a;
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
  }
  function o(a, u, i, b, d) {
    if (process.env.NODE_ENV !== "production") {
      for (var m in a)
        if (n(a, m)) {
          var s;
          try {
            if (typeof a[m] != "function") {
              var v = Error(
                (b || "React class") + ": " + i + " type `" + m + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[m] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw v.name = "Invariant Violation", v;
            }
            s = a[m](u, m, b, i, null, r);
          } catch (S) {
            s = S;
          }
          if (s && !(s instanceof Error) && e(
            (b || "React class") + ": type specification of " + i + " `" + m + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof s + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), s instanceof Error && !(s.message in t)) {
            t[s.message] = !0;
            var g = d ? d() : "";
            e(
              "Failed " + i + " type: " + s.message + (g ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, Ve = o, Ve;
}
var He, Mr;
function an() {
  if (Mr) return He;
  Mr = 1;
  var e = Qr(), r = nn(), t = dr(), n = et(), o = on(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(i) {
    var b = "Warning: " + i;
    typeof console < "u" && console.error(b);
    try {
      throw new Error(b);
    } catch {
    }
  });
  function u() {
    return null;
  }
  return He = function(i, b) {
    var d = typeof Symbol == "function" && Symbol.iterator, m = "@@iterator";
    function s(l) {
      var E = l && (d && l[d] || l[m]);
      if (typeof E == "function")
        return E;
    }
    var v = "<<anonymous>>", g = {
      array: p("array"),
      bigint: p("bigint"),
      bool: p("boolean"),
      func: p("function"),
      number: p("number"),
      object: p("object"),
      string: p("string"),
      symbol: p("symbol"),
      any: C(),
      arrayOf: w,
      element: T(),
      elementType: f(),
      instanceOf: W,
      node: ne(),
      objectOf: B,
      oneOf: j,
      oneOfType: G,
      shape: ee,
      exact: Z
    };
    function S(l, E) {
      return l === E ? l !== 0 || 1 / l === 1 / E : l !== l && E !== E;
    }
    function c(l, E) {
      this.message = l, this.data = E && typeof E == "object" ? E : {}, this.stack = "";
    }
    c.prototype = Error.prototype;
    function y(l) {
      if (process.env.NODE_ENV !== "production")
        var E = {}, _ = 0;
      function x(A, R, F, I, M, k, $) {
        if (I = I || v, k = k || F, $ !== t) {
          if (b) {
            var h = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw h.name = "Invariant Violation", h;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var U = I + ":" + F;
            !E[U] && // Avoid spamming the console because they are often not actionable except for lib authors
            _ < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + k + "` prop on `" + I + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), E[U] = !0, _++);
          }
        }
        return R[F] == null ? A ? R[F] === null ? new c("The " + M + " `" + k + "` is marked as required " + ("in `" + I + "`, but its value is `null`.")) : new c("The " + M + " `" + k + "` is marked as required in " + ("`" + I + "`, but its value is `undefined`.")) : null : l(R, F, I, M, k);
      }
      var P = x.bind(null, !1);
      return P.isRequired = x.bind(null, !0), P;
    }
    function p(l) {
      function E(_, x, P, A, R, F) {
        var I = _[x], M = Y(I);
        if (M !== l) {
          var k = K(I);
          return new c(
            "Invalid " + A + " `" + R + "` of type " + ("`" + k + "` supplied to `" + P + "`, expected ") + ("`" + l + "`."),
            { expectedType: l }
          );
        }
        return null;
      }
      return y(E);
    }
    function C() {
      return y(u);
    }
    function w(l) {
      function E(_, x, P, A, R) {
        if (typeof l != "function")
          return new c("Property `" + R + "` of component `" + P + "` has invalid PropType notation inside arrayOf.");
        var F = _[x];
        if (!Array.isArray(F)) {
          var I = Y(F);
          return new c("Invalid " + A + " `" + R + "` of type " + ("`" + I + "` supplied to `" + P + "`, expected an array."));
        }
        for (var M = 0; M < F.length; M++) {
          var k = l(F, M, P, A, R + "[" + M + "]", t);
          if (k instanceof Error)
            return k;
        }
        return null;
      }
      return y(E);
    }
    function T() {
      function l(E, _, x, P, A) {
        var R = E[_];
        if (!i(R)) {
          var F = Y(R);
          return new c("Invalid " + P + " `" + A + "` of type " + ("`" + F + "` supplied to `" + x + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(l);
    }
    function f() {
      function l(E, _, x, P, A) {
        var R = E[_];
        if (!e.isValidElementType(R)) {
          var F = Y(R);
          return new c("Invalid " + P + " `" + A + "` of type " + ("`" + F + "` supplied to `" + x + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(l);
    }
    function W(l) {
      function E(_, x, P, A, R) {
        if (!(_[x] instanceof l)) {
          var F = l.name || v, I = se(_[x]);
          return new c("Invalid " + A + " `" + R + "` of type " + ("`" + I + "` supplied to `" + P + "`, expected ") + ("instance of `" + F + "`."));
        }
        return null;
      }
      return y(E);
    }
    function j(l) {
      if (!Array.isArray(l))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), u;
      function E(_, x, P, A, R) {
        for (var F = _[x], I = 0; I < l.length; I++)
          if (S(F, l[I]))
            return null;
        var M = JSON.stringify(l, function($, h) {
          var U = K(h);
          return U === "symbol" ? String(h) : h;
        });
        return new c("Invalid " + A + " `" + R + "` of value `" + String(F) + "` " + ("supplied to `" + P + "`, expected one of " + M + "."));
      }
      return y(E);
    }
    function B(l) {
      function E(_, x, P, A, R) {
        if (typeof l != "function")
          return new c("Property `" + R + "` of component `" + P + "` has invalid PropType notation inside objectOf.");
        var F = _[x], I = Y(F);
        if (I !== "object")
          return new c("Invalid " + A + " `" + R + "` of type " + ("`" + I + "` supplied to `" + P + "`, expected an object."));
        for (var M in F)
          if (n(F, M)) {
            var k = l(F, M, P, A, R + "." + M, t);
            if (k instanceof Error)
              return k;
          }
        return null;
      }
      return y(E);
    }
    function G(l) {
      if (!Array.isArray(l))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), u;
      for (var E = 0; E < l.length; E++) {
        var _ = l[E];
        if (typeof _ != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ce(_) + " at index " + E + "."
          ), u;
      }
      function x(P, A, R, F, I) {
        for (var M = [], k = 0; k < l.length; k++) {
          var $ = l[k], h = $(P, A, R, F, I, t);
          if (h == null)
            return null;
          h.data && n(h.data, "expectedType") && M.push(h.data.expectedType);
        }
        var U = M.length > 0 ? ", expected one of type [" + M.join(", ") + "]" : "";
        return new c("Invalid " + F + " `" + I + "` supplied to " + ("`" + R + "`" + U + "."));
      }
      return y(x);
    }
    function ne() {
      function l(E, _, x, P, A) {
        return V(E[_]) ? null : new c("Invalid " + P + " `" + A + "` supplied to " + ("`" + x + "`, expected a ReactNode."));
      }
      return y(l);
    }
    function Q(l, E, _, x, P) {
      return new c(
        (l || "React class") + ": " + E + " type `" + _ + "." + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + P + "`."
      );
    }
    function ee(l) {
      function E(_, x, P, A, R) {
        var F = _[x], I = Y(F);
        if (I !== "object")
          return new c("Invalid " + A + " `" + R + "` of type `" + I + "` " + ("supplied to `" + P + "`, expected `object`."));
        for (var M in l) {
          var k = l[M];
          if (typeof k != "function")
            return Q(P, A, R, M, K(k));
          var $ = k(F, M, P, A, R + "." + M, t);
          if ($)
            return $;
        }
        return null;
      }
      return y(E);
    }
    function Z(l) {
      function E(_, x, P, A, R) {
        var F = _[x], I = Y(F);
        if (I !== "object")
          return new c("Invalid " + A + " `" + R + "` of type `" + I + "` " + ("supplied to `" + P + "`, expected `object`."));
        var M = r({}, _[x], l);
        for (var k in M) {
          var $ = l[k];
          if (n(l, k) && typeof $ != "function")
            return Q(P, A, R, k, K($));
          if (!$)
            return new c(
              "Invalid " + A + " `" + R + "` key `" + k + "` supplied to `" + P + "`.\nBad object: " + JSON.stringify(_[x], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(l), null, "  ")
            );
          var h = $(F, k, P, A, R + "." + k, t);
          if (h)
            return h;
        }
        return null;
      }
      return y(E);
    }
    function V(l) {
      switch (typeof l) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !l;
        case "object":
          if (Array.isArray(l))
            return l.every(V);
          if (l === null || i(l))
            return !0;
          var E = s(l);
          if (E) {
            var _ = E.call(l), x;
            if (E !== l.entries) {
              for (; !(x = _.next()).done; )
                if (!V(x.value))
                  return !1;
            } else
              for (; !(x = _.next()).done; ) {
                var P = x.value;
                if (P && !V(P[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function re(l, E) {
      return l === "symbol" ? !0 : E ? E["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && E instanceof Symbol : !1;
    }
    function Y(l) {
      var E = typeof l;
      return Array.isArray(l) ? "array" : l instanceof RegExp ? "object" : re(E, l) ? "symbol" : E;
    }
    function K(l) {
      if (typeof l > "u" || l === null)
        return "" + l;
      var E = Y(l);
      if (E === "object") {
        if (l instanceof Date)
          return "date";
        if (l instanceof RegExp)
          return "regexp";
      }
      return E;
    }
    function ce(l) {
      var E = K(l);
      switch (E) {
        case "array":
        case "object":
          return "an " + E;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + E;
        default:
          return E;
      }
    }
    function se(l) {
      return !l.constructor || !l.constructor.name ? v : l.constructor.name;
    }
    return g.checkPropTypes = o, g.resetWarningCache = o.resetWarningCache, g.PropTypes = g, g;
  }, He;
}
var Ge, Lr;
function un() {
  if (Lr) return Ge;
  Lr = 1;
  var e = dr();
  function r() {
  }
  function t() {
  }
  return t.resetWarningCache = r, Ge = function() {
    function n(u, i, b, d, m, s) {
      if (s !== e) {
        var v = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw v.name = "Invariant Violation", v;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: r
    };
    return a.PropTypes = a, a;
  }, Ge;
}
if (process.env.NODE_ENV !== "production") {
  var cn = Qr(), sn = !0;
  rr.exports = an()(cn.isElement, sn);
} else
  rr.exports = un()();
var D = rr.exports;
const rt = /* @__PURE__ */ Gt(D);
var tr = "data-focus-lock", tt = "data-focus-lock-disabled", fn = "data-no-focus-lock", ln = "data-autofocus-inside", dn = "data-no-autofocus", Xe = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && rt.node;
var nt = cr({}, function(e) {
  var r = e.target, t = e.currentTarget;
  return {
    target: r,
    currentTarget: t
  };
}), ot = cr(), vn = cr(), at = sr({
  async: !0,
  ssr: typeof document < "u"
}), mn = /* @__PURE__ */ Wt(void 0), hn = [], it = /* @__PURE__ */ jt(function(r, t) {
  var n, o = we(), a = o[0], u = o[1], i = Oe(), b = Oe(!1), d = Oe(null), m = we({}), s = m[1], v = r.children, g = r.disabled, S = g === void 0 ? !1 : g, c = r.noFocusGuards, y = c === void 0 ? !1 : c, p = r.persistentFocus, C = p === void 0 ? !1 : p, w = r.crossFrame, T = w === void 0 ? !0 : w, f = r.autoFocus, W = f === void 0 ? !0 : f, j = r.allowTextSelection, B = r.group, G = r.className, ne = r.whiteList, Q = r.hasPositiveIndices, ee = r.shards, Z = ee === void 0 ? hn : ee, V = r.as, re = V === void 0 ? "div" : V, Y = r.lockProps, K = Y === void 0 ? {} : Y, ce = r.sideCar, se = r.returnFocus, l = se === void 0 ? !1 : se, E = r.focusOptions, _ = r.onActivation, x = r.onDeactivation, P = we({}), A = P[0], R = ae(function(J) {
    var le = J.captureFocusRestore;
    if (!d.current) {
      var de, oe = (de = document) == null ? void 0 : de.activeElement;
      d.current = oe, oe !== document.body && (d.current = le(oe));
    }
    i.current && _ && _(i.current), b.current = !0, s();
  }, [_]), F = ae(function() {
    b.current = !1, x && x(i.current), s();
  }, [x]), I = ae(function(J) {
    var le = d.current;
    if (le) {
      var de = (typeof le == "function" ? le() : le) || document.body, oe = typeof l == "function" ? l(de) : l;
      if (oe) {
        var Cr = typeof oe == "object" ? oe : void 0;
        d.current = null, J ? Promise.resolve().then(function() {
          return de.focus(Cr);
        }) : de.focus(Cr);
      }
    }
  }, [l]), M = ae(function(J) {
    b.current && nt.useMedium(J);
  }, []), k = ot.useMedium, $ = ae(function(J) {
    i.current !== J && (i.current = J, u(J));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof j < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), Ne(function() {
    !i.current && typeof re != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var h = We((n = {}, n[tt] = S && "disabled", n[tr] = B, n), K), U = y !== !0, fe = U && y !== "tail", _e = Gr([t, $]), Lt = $t(function() {
    return {
      observed: i,
      shards: Z,
      enabled: !S,
      active: b.current
    };
  }, [S, b.current, Z, a]);
  return /* @__PURE__ */ te.createElement(Bt, null, U && [
    /* @__PURE__ */ te.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: S ? -1 : 0,
      style: Xe
    }),
    Q ? /* @__PURE__ */ te.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: S ? -1 : 1,
      style: Xe
    }) : null
  ], !S && /* @__PURE__ */ te.createElement(ce, {
    id: A,
    sideCar: at,
    observed: a,
    disabled: S,
    persistentFocus: C,
    crossFrame: T,
    autoFocus: W,
    whiteList: ne,
    shards: Z,
    onActivation: R,
    onDeactivation: F,
    returnFocus: I,
    focusOptions: E,
    noFocusGuards: y
  }), /* @__PURE__ */ te.createElement(re, We({
    ref: _e
  }, h, {
    className: G,
    onBlur: k,
    onFocus: M
  }), /* @__PURE__ */ te.createElement(mn.Provider, {
    value: Lt
  }, v)), fe && /* @__PURE__ */ te.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: S ? -1 : 0,
    style: Xe
  }));
});
it.propTypes = process.env.NODE_ENV !== "production" ? {
  children: D.node,
  disabled: D.bool,
  returnFocus: D.oneOfType([D.bool, D.object, D.func]),
  focusOptions: D.object,
  noFocusGuards: D.bool,
  hasPositiveIndices: D.bool,
  allowTextSelection: D.bool,
  autoFocus: D.bool,
  persistentFocus: D.bool,
  crossFrame: D.bool,
  group: D.string,
  className: D.string,
  whiteList: D.func,
  shards: D.arrayOf(D.any),
  as: D.oneOfType([D.string, D.func, D.object]),
  lockProps: D.object,
  onActivation: D.func,
  onDeactivation: D.func,
  sideCar: D.any.isRequired
} : {};
function vr(e) {
  setTimeout(e, 1);
}
var pn = function(r) {
  return r && "current" in r ? r.current : r;
}, ut = sr(), ct = "data-focus-on-hidden", yn = { preventScroll: !0 }, bn = O.forwardRef(function(e, r) {
  var t = O.useState(!1), n = t[0], o = t[1], a = e.children, u = e.autoFocus, i = e.shards, b = e.crossFrame, d = e.enabled, m = d === void 0 ? !0 : d, s = e.scrollLock, v = s === void 0 ? !0 : s, g = e.focusLock, S = g === void 0 ? !0 : g, c = e.returnFocus, y = c === void 0 ? !0 : c, p = e.inert, C = e.allowPinchZoom, w = e.sideCar, T = e.className, f = e.shouldIgnore, W = e.preventScrollOnFocus, j = e.style, B = e.as, G = e.gapMode, ne = De(e, ["children", "autoFocus", "shards", "crossFrame", "enabled", "scrollLock", "focusLock", "returnFocus", "inert", "allowPinchZoom", "sideCar", "className", "shouldIgnore", "preventScrollOnFocus", "style", "as", "gapMode"]), Q = w, ee = n.onActivation, Z = n.onDeactivation, V = De(n, ["onActivation", "onDeactivation"]), re = q(q({}, V), {
    as: B,
    style: j,
    sideCar: w,
    shards: i,
    allowPinchZoom: C,
    gapMode: G,
    inert: p,
    enabled: m && v
  });
  return O.createElement(
    O.Fragment,
    null,
    O.createElement(it, { ref: r, sideCar: w, disabled: !(n && m && S), returnFocus: y, autoFocus: u, shards: i, crossFrame: b, onActivation: ee, onDeactivation: Z, className: T, whiteList: f, lockProps: re, focusOptions: W ? yn : void 0, as: lr }, a),
    m && O.createElement(Q, q({}, ne, { sideCar: ut, setLockProps: o, shards: i }))
  );
});
function nr(e, r) {
  return nr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, nr(e, r);
}
function gn(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, nr(e, r);
}
function Te(e) {
  "@babel/helpers - typeof";
  return Te = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Te(e);
}
function En(e, r) {
  if (Te(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (Te(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function Sn(e) {
  var r = En(e, "string");
  return Te(r) == "symbol" ? r : r + "";
}
function wn(e, r, t) {
  return (r = Sn(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function On(e, r) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e != "function")
      throw new Error("Expected reducePropsToState to be a function.");
    if (typeof r != "function")
      throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function t(n) {
    return n.displayName || n.name || "Component";
  }
  return function(o) {
    if (process.env.NODE_ENV !== "production" && typeof o != "function")
      throw new Error("Expected WrappedComponent to be a React component.");
    var a = [], u;
    function i() {
      u = e(a.map(function(d) {
        return d.props;
      })), r(u);
    }
    var b = /* @__PURE__ */ function(d) {
      gn(m, d);
      function m() {
        return d.apply(this, arguments) || this;
      }
      m.peek = function() {
        return u;
      };
      var s = m.prototype;
      return s.componentDidMount = function() {
        a.push(this), i();
      }, s.componentDidUpdate = function() {
        i();
      }, s.componentWillUnmount = function() {
        var g = a.indexOf(this);
        a.splice(g, 1), i();
      }, s.render = function() {
        return /* @__PURE__ */ te.createElement(o, this.props);
      }, m;
    }(zt);
    return wn(b, "displayName", "SideEffect(" + t(o) + ")"), b;
  };
}
var X = function(e) {
  for (var r = Array(e.length), t = 0; t < e.length; ++t)
    r[t] = e[t];
  return r;
}, ue = function(e) {
  return Array.isArray(e) ? e : [e];
}, st = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, Tn = function(e) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var r = window.getComputedStyle(e, null);
  return !r || !r.getPropertyValue ? !1 : r.getPropertyValue("display") === "none" || r.getPropertyValue("visibility") === "hidden";
}, ft = function(e) {
  return e.parentNode && e.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e.parentNode.host
  ) : e.parentNode;
}, lt = function(e) {
  return e === document || e && e.nodeType === Node.DOCUMENT_NODE;
}, Cn = function(e) {
  return e.hasAttribute("inert");
}, Pn = function(e, r) {
  return !e || lt(e) || !Tn(e) && !Cn(e) && r(ft(e));
}, dt = function(e, r) {
  var t = e.get(r);
  if (t !== void 0)
    return t;
  var n = Pn(r, dt.bind(void 0, e));
  return e.set(r, n), n;
}, xn = function(e, r) {
  return e && !lt(e) ? Fn(e) ? r(ft(e)) : !1 : !0;
}, vt = function(e, r) {
  var t = e.get(r);
  if (t !== void 0)
    return t;
  var n = xn(r, vt.bind(void 0, e));
  return e.set(r, n), n;
}, mt = function(e) {
  return e.dataset;
}, _n = function(e) {
  return e.tagName === "BUTTON";
}, ht = function(e) {
  return e.tagName === "INPUT";
}, pt = function(e) {
  return ht(e) && e.type === "radio";
}, Rn = function(e) {
  return !((ht(e) || _n(e)) && (e.type === "hidden" || e.disabled));
}, Fn = function(e) {
  var r = e.getAttribute(dn);
  return ![!0, "true", ""].includes(r);
}, mr = function(e) {
  var r;
  return !!(e && (!((r = mt(e)) === null || r === void 0) && r.focusGuard));
}, or = function(e) {
  return !mr(e);
}, An = function(e) {
  return !!e;
}, In = function(e, r) {
  var t = Math.max(0, e.tabIndex), n = Math.max(0, r.tabIndex), o = t - n, a = e.index - r.index;
  if (o) {
    if (!t)
      return 1;
    if (!n)
      return -1;
  }
  return o || a;
}, kn = function(e) {
  return e.tabIndex < 0 && !e.hasAttribute("tabindex") ? 0 : e.tabIndex;
}, hr = function(e, r, t) {
  return X(e).map(function(n, o) {
    var a = kn(n);
    return {
      node: n,
      index: o,
      tabIndex: t && a === -1 ? (n.dataset || {}).focusGuard ? 0 : -1 : a
    };
  }).filter(function(n) {
    return !r || n.tabIndex >= 0;
  }).sort(In);
}, Mn = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], pr = Mn.join(","), Ln = "".concat(pr, ", [data-focus-guard]"), yt = function(e, r) {
  return X((e.shadowRoot || e).children).reduce(function(t, n) {
    return t.concat(n.matches(r ? Ln : pr) ? [n] : [], yt(n));
  }, []);
}, Nn = function(e, r) {
  var t;
  return e instanceof HTMLIFrameElement && (!((t = e.contentDocument) === null || t === void 0) && t.body) ? Ee([e.contentDocument.body], r) : [e];
}, Ee = function(e, r) {
  return e.reduce(function(t, n) {
    var o, a = yt(n, r), u = (o = []).concat.apply(o, a.map(function(i) {
      return Nn(i, r);
    }));
    return t.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      u,
      // add if node is tabbable itself
      n.parentNode ? X(n.parentNode.querySelectorAll(pr)).filter(function(i) {
        return i === n;
      }) : []
    );
  }, []);
}, Dn = function(e) {
  var r = e.querySelectorAll("[".concat(ln, "]"));
  return X(r).map(function(t) {
    return Ee([t]);
  }).reduce(function(t, n) {
    return t.concat(n);
  }, []);
}, yr = function(e, r) {
  return X(e).filter(function(t) {
    return dt(r, t);
  }).filter(function(t) {
    return Rn(t);
  });
}, Nr = function(e, r) {
  return r === void 0 && (r = /* @__PURE__ */ new Map()), X(e).filter(function(t) {
    return vt(r, t);
  });
}, br = function(e, r, t) {
  return hr(yr(Ee(e, t), r), !0, t);
}, Ce = function(e, r) {
  return hr(yr(Ee(e), r), !1);
}, Wn = function(e, r) {
  return yr(Dn(e), r);
}, ie = function(e, r) {
  return e.shadowRoot ? ie(e.shadowRoot, r) : Object.getPrototypeOf(e).contains !== void 0 && Object.getPrototypeOf(e).contains.call(e, r) ? !0 : X(e.children).some(function(t) {
    var n;
    if (t instanceof HTMLIFrameElement) {
      var o = (n = t.contentDocument) === null || n === void 0 ? void 0 : n.body;
      return o ? ie(o, r) : !1;
    }
    return ie(t, r);
  });
}, jn = function(e) {
  for (var r = /* @__PURE__ */ new Set(), t = e.length, n = 0; n < t; n += 1)
    for (var o = n + 1; o < t; o += 1) {
      var a = e[n].compareDocumentPosition(e[o]);
      (a & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && r.add(o), (a & Node.DOCUMENT_POSITION_CONTAINS) > 0 && r.add(n);
    }
  return e.filter(function(u, i) {
    return !r.has(i);
  });
}, bt = function(e) {
  return e.parentNode ? bt(e.parentNode) : e;
}, gr = function(e) {
  var r = ue(e);
  return r.filter(Boolean).reduce(function(t, n) {
    var o = n.getAttribute(tr);
    return t.push.apply(t, o ? jn(X(bt(n).querySelectorAll("[".concat(tr, '="').concat(o, '"]:not([').concat(tt, '="disabled"])')))) : [n]), t;
  }, []);
}, $n = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, Pe = function(e) {
  if (e === void 0 && (e = document), !(!e || !e.activeElement)) {
    var r = e.activeElement;
    return r.shadowRoot ? Pe(r.shadowRoot) : r instanceof HTMLIFrameElement && $n(function() {
      return r.contentWindow.document;
    }) ? Pe(r.contentWindow.document) : r;
  }
}, Bn = function(e, r) {
  return e === r;
}, zn = function(e, r) {
  return !!X(e.querySelectorAll("iframe")).some(function(t) {
    return Bn(t, r);
  });
}, gt = function(e, r) {
  return r === void 0 && (r = Pe(st(e).ownerDocument)), !r || r.dataset && r.dataset.focusGuard ? !1 : gr(e).some(function(t) {
    return ie(t, r) || zn(t, r);
  });
}, qn = function(e) {
  e === void 0 && (e = document);
  var r = Pe(e);
  return r ? X(e.querySelectorAll("[".concat(fn, "]"))).some(function(t) {
    return ie(t, r);
  }) : !1;
}, Yn = function(e, r) {
  return r.filter(pt).filter(function(t) {
    return t.name === e.name;
  }).filter(function(t) {
    return t.checked;
  })[0] || e;
}, Er = function(e, r) {
  return pt(e) && e.name ? Yn(e, r) : e;
}, Un = function(e) {
  var r = /* @__PURE__ */ new Set();
  return e.forEach(function(t) {
    return r.add(Er(t, e));
  }), e.filter(function(t) {
    return r.has(t);
  });
}, Dr = function(e) {
  return e[0] && e.length > 1 ? Er(e[0], e) : e[0];
}, Wr = function(e, r) {
  return e.indexOf(Er(r, e));
}, ar = "NEW_FOCUS", Vn = function(e, r, t, n, o) {
  var a = e.length, u = e[0], i = e[a - 1], b = mr(n);
  if (!(n && e.indexOf(n) >= 0)) {
    var d = n !== void 0 ? t.indexOf(n) : -1, m = o ? t.indexOf(o) : d, s = o ? e.indexOf(o) : -1;
    if (d === -1)
      return s !== -1 ? s : ar;
    if (s === -1)
      return ar;
    var v = d - m, g = t.indexOf(u), S = t.indexOf(i), c = Un(t), y = n !== void 0 ? c.indexOf(n) : -1, p = o ? c.indexOf(o) : y, C = c.filter(function(B) {
      return B.tabIndex >= 0;
    }), w = n !== void 0 ? C.indexOf(n) : -1, T = o ? C.indexOf(o) : w, f = w >= 0 && T >= 0 ? (
      // old/new are tabbables, measure distance in tabbable space
      T - w
    ) : (
      // or else measure in focusable space
      p - y
    );
    if (!v && s >= 0 || r.length === 0)
      return s;
    var W = Wr(e, r[0]), j = Wr(e, r[r.length - 1]);
    if (d <= g && b && Math.abs(v) > 1)
      return j;
    if (d >= S && b && Math.abs(v) > 1)
      return W;
    if (v && Math.abs(f) > 1)
      return s;
    if (d <= g)
      return j;
    if (d > S)
      return W;
    if (v)
      return Math.abs(v) > 1 ? s : (a + s + v) % a;
  }
}, Hn = function(e) {
  return function(r) {
    var t, n = (t = mt(r)) === null || t === void 0 ? void 0 : t.autofocus;
    return (
      // @ts-expect-error
      r.autofocus || //
      n !== void 0 && n !== "false" || //
      e.indexOf(r) >= 0
    );
  };
}, jr = function(e, r, t) {
  var n = e.map(function(a) {
    var u = a.node;
    return u;
  }), o = Nr(n.filter(Hn(t)));
  return o && o.length ? Dr(o) : Dr(Nr(r));
}, ir = function(e, r) {
  return r === void 0 && (r = []), r.push(e), e.parentNode && ir(e.parentNode.host || e.parentNode, r), r;
}, Ze = function(e, r) {
  for (var t = ir(e), n = ir(r), o = 0; o < t.length; o += 1) {
    var a = t[o];
    if (n.indexOf(a) >= 0)
      return a;
  }
  return !1;
}, Et = function(e, r, t) {
  var n = ue(e), o = ue(r), a = n[0], u = !1;
  return o.filter(Boolean).forEach(function(i) {
    u = Ze(u || i, i) || u, t.filter(Boolean).forEach(function(b) {
      var d = Ze(a, b);
      d && (!u || ie(d, u) ? u = d : u = Ze(d, u));
    });
  }), u;
}, $r = function(e, r) {
  return e.reduce(function(t, n) {
    return t.concat(Wn(n, r));
  }, []);
}, Gn = function(e, r) {
  var t = /* @__PURE__ */ new Map();
  return r.forEach(function(n) {
    return t.set(n.node, n);
  }), e.map(function(n) {
    return t.get(n);
  }).filter(An);
}, Xn = function(e, r) {
  var t = Pe(ue(e).length > 0 ? document : st(e).ownerDocument), n = gr(e).filter(or), o = Et(t || e, e, n), a = /* @__PURE__ */ new Map(), u = Ce(n, a), i = u.filter(function(S) {
    var c = S.node;
    return or(c);
  });
  if (i[0]) {
    var b = Ce([o], a).map(function(S) {
      var c = S.node;
      return c;
    }), d = Gn(b, i), m = d.map(function(S) {
      var c = S.node;
      return c;
    }), s = d.filter(function(S) {
      var c = S.tabIndex;
      return c >= 0;
    }).map(function(S) {
      var c = S.node;
      return c;
    }), v = Vn(m, s, b, t, r);
    if (v === ar) {
      var g = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        jr(u, s, $r(n, a)) || jr(u, m, $r(n, a))
      );
      if (g)
        return { node: g };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return v === void 0 ? v : d[v];
  }
}, Zn = function(e) {
  var r = gr(e).filter(or), t = Et(e, e, r), n = hr(Ee([t], !0), !0, !0), o = Ee(r, !1);
  return n.map(function(a) {
    var u = a.node, i = a.index;
    return {
      node: u,
      index: i,
      lockItem: o.indexOf(u) >= 0,
      guard: mr(u)
    };
  });
}, Sr = function(e, r) {
  e && ("focus" in e && e.focus(r), "contentWindow" in e && e.contentWindow && e.contentWindow.focus());
}, Ke = 0, Je = !1, St = function(e, r, t) {
  t === void 0 && (t = {});
  var n = Xn(e, r);
  if (!Je && n) {
    if (Ke > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), Je = !0, setTimeout(function() {
        Je = !1;
      }, 1);
      return;
    }
    Ke++, Sr(n.node, t.focusOptions), Ke--;
  }
};
function Se(e) {
  if (!e)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return e || null;
    };
  var r = e ? new WeakRef(e) : null;
  return function() {
    return (r == null ? void 0 : r.deref()) || null;
  };
}
var Kn = function(e) {
  if (!e)
    return null;
  for (var r = [], t = e; t && t !== document.body; )
    r.push({
      current: Se(t),
      parent: Se(t.parentElement),
      left: Se(t.previousElementSibling),
      right: Se(t.nextElementSibling)
    }), t = t.parentElement;
  return {
    element: Se(e),
    stack: r,
    ownerDocument: e.ownerDocument
  };
}, Jn = function(e) {
  var r, t, n, o, a;
  if (e)
    for (var u = e.stack, i = e.ownerDocument, b = /* @__PURE__ */ new Map(), d = 0, m = u; d < m.length; d++) {
      var s = m[d], v = (r = s.parent) === null || r === void 0 ? void 0 : r.call(s);
      if (v && i.contains(v)) {
        for (var g = (t = s.left) === null || t === void 0 ? void 0 : t.call(s), S = s.current(), c = v.contains(S) ? S : void 0, y = (n = s.right) === null || n === void 0 ? void 0 : n.call(s), p = br([v], b), C = (
          // that is element itself
          (a = (o = c ?? // or something in it's place
          (g == null ? void 0 : g.nextElementSibling)) !== null && o !== void 0 ? o : (
            // or somebody to the right, still close enough
            y
          )) !== null && a !== void 0 ? a : (
            // or somebody to the left, something?
            g
          )
        ); C; ) {
          for (var w = 0, T = p; w < T.length; w++) {
            var f = T[w];
            if (C != null && C.contains(f.node))
              return f.node;
          }
          C = C.nextElementSibling;
        }
        if (p.length)
          return p[0].node;
      }
    }
}, wt = function(e) {
  var r = Kn(e);
  return function() {
    return Jn(r);
  };
}, Qn = function(e, r, t) {
  if (!e || !r)
    return console.error("no element or scope given"), {};
  var n = ue(r);
  if (n.every(function(u) {
    return !ie(u, e);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var o = t ? br(n, /* @__PURE__ */ new Map()) : Ce(n, /* @__PURE__ */ new Map()), a = o.findIndex(function(u) {
    var i = u.node;
    return i === e;
  });
  if (a !== -1)
    return {
      prev: o[a - 1],
      next: o[a + 1],
      first: o[0],
      last: o[o.length - 1]
    };
}, eo = function(e, r) {
  var t = r ? br(ue(e), /* @__PURE__ */ new Map()) : Ce(ue(e), /* @__PURE__ */ new Map());
  return {
    first: t[0],
    last: t[t.length - 1]
  };
}, ro = function(e) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, e);
}, Ot = function(e, r, t) {
  r === void 0 && (r = {});
  var n = ro(r), o = Qn(e, n.scope, n.onlyTabbable);
  if (o) {
    var a = t(o, n.cycle);
    a && Sr(a.node, n.focusOptions);
  }
}, to = function(e, r) {
  r === void 0 && (r = {}), Ot(e, r, function(t, n) {
    var o = t.next, a = t.first;
    return o || n && a;
  });
}, no = function(e, r) {
  r === void 0 && (r = {}), Ot(e, r, function(t, n) {
    var o = t.prev, a = t.last;
    return o || n && a;
  });
}, Tt = function(e, r, t) {
  var n, o = eo(e, (n = r.onlyTabbable) !== null && n !== void 0 ? n : !0), a = o[t];
  a && Sr(a.node, r.focusOptions);
}, oo = function(e, r) {
  r === void 0 && (r = {}), Tt(e, r, "first");
}, ao = function(e, r) {
  r === void 0 && (r = {}), Tt(e, r, "last");
}, Ct = function() {
  return document && document.activeElement === document.body;
}, io = function() {
  return Ct() || qn();
}, ye = null, z = null, Br = function() {
  return null;
}, be = null, xe = !1, wr = !1, uo = function() {
  return !0;
}, co = function(r) {
  return (ye.whiteList || uo)(r);
}, so = function(r, t) {
  be = {
    observerNode: r,
    portaledElement: t
  };
}, fo = function(r) {
  return be && be.portaledElement === r;
};
function zr(e, r, t, n) {
  var o = null, a = e;
  do {
    var u = n[a];
    if (u.guard)
      u.node.dataset.focusAutoGuard && (o = u);
    else if (u.lockItem) {
      if (a !== e)
        return;
      o = null;
    } else
      break;
  } while ((a += t) !== r);
  o && (o.node.tabIndex = 0);
}
var lo = function(r) {
  return r ? !!xe : xe === "meanwhile";
}, vo = function e(r, t, n) {
  return t && (t.host === r && (!t.activeElement || n.contains(t.activeElement)) || t.parentNode && e(r, t.parentNode, n));
}, mo = function(r, t) {
  return t.some(function(n) {
    return vo(r, n, n);
  });
}, Pt = function(r) {
  return Ce(r, /* @__PURE__ */ new Map());
}, ho = function(r) {
  return !Pt([r.parentNode]).some(function(t) {
    return t.node === r;
  });
}, je = function() {
  var r = !1;
  if (ye) {
    var t = ye, n = t.observed, o = t.persistentFocus, a = t.autoFocus, u = t.shards, i = t.crossFrame, b = t.focusOptions, d = t.noFocusGuards, m = n || be && be.portaledElement;
    if (Ct() && z && z !== document.body && (!document.body.contains(z) || ho(z))) {
      var s = Br();
      s && s.focus();
    }
    var v = document && document.activeElement;
    if (m) {
      var g = [m].concat(u.map(pn).filter(Boolean)), S = function() {
        if (!lo(i) || !d || !z || wr)
          return !1;
        var w = Pt(g), T = w.findIndex(function(f) {
          var W = f.node;
          return W === z;
        });
        return T === 0 || T === w.length - 1;
      };
      if ((!v || co(v)) && (o || S() || !io() || !z && a) && (m && !(gt(g) || v && mo(v, g) || fo(v)) && (document && !z && v && !a ? (v.blur && v.blur(), document.body.focus()) : (r = St(g, z, {
        focusOptions: b
      }), be = {})), z = document && document.activeElement, z !== document.body && (Br = wt(z)), xe = !1), document && v !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var c = document && document.activeElement, y = Zn(g), p = y.map(function(C) {
          var w = C.node;
          return w;
        }).indexOf(c);
        p > -1 && (y.filter(function(C) {
          var w = C.guard, T = C.node;
          return w && T.dataset.focusAutoGuard;
        }).forEach(function(C) {
          var w = C.node;
          return w.removeAttribute("tabIndex");
        }), zr(p, y.length, 1, y), zr(p, -1, -1, y));
      }
    }
  }
  return r;
}, xt = function(r) {
  je() && r && (r.stopPropagation(), r.preventDefault());
}, Or = function() {
  return vr(je);
}, po = function(r) {
  var t = r.target, n = r.currentTarget;
  n.contains(t) || so(n, t);
}, yo = function() {
  return null;
};
process.env.NODE_ENV !== "production" && rt.node.isRequired;
var _t = function() {
  wr = !0;
}, Rt = function() {
  wr = !1, xe = "just", vr(function() {
    xe = "meanwhile";
  });
}, bo = function() {
  document.addEventListener("focusin", xt), document.addEventListener("focusout", Or), window.addEventListener("focus", _t), window.addEventListener("blur", Rt);
}, go = function() {
  document.removeEventListener("focusin", xt), document.removeEventListener("focusout", Or), window.removeEventListener("focus", _t), window.removeEventListener("blur", Rt);
};
function Eo(e) {
  return e.filter(function(r) {
    var t = r.disabled;
    return !t;
  });
}
var Ft = {
  moveFocusInside: St,
  focusInside: gt,
  focusNextElement: to,
  focusPrevElement: no,
  focusFirstElement: oo,
  focusLastElement: ao,
  captureFocusRestore: wt
};
function So(e) {
  var r = e.slice(-1)[0];
  r && !ye && bo();
  var t = ye, n = t && r && r.id === t.id;
  ye = r, t && !n && (t.onDeactivation(), e.filter(function(o) {
    var a = o.id;
    return a === t.id;
  }).length || t.returnFocus(!r)), r ? (z = null, (!n || t.observed !== r.observed) && r.onActivation(Ft), je(), vr(je)) : (go(), z = null);
}
nt.assignSyncMedium(po);
ot.assignMedium(Or);
vn.assignMedium(function(e) {
  return e(Ft);
});
const wo = On(Eo, So)(yo);
fr(at, wo);
var Oo = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function To() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var r = Oo();
  return r && e.setAttribute("nonce", r), e;
}
function Co(e, r) {
  e.styleSheet ? e.styleSheet.cssText = r : e.appendChild(document.createTextNode(r));
}
function Po(e) {
  var r = document.head || document.getElementsByTagName("head")[0];
  r.appendChild(e);
}
var xo = function() {
  var e = 0, r = null;
  return {
    add: function(t) {
      e == 0 && (r = To()) && (Co(r, t), Po(r)), e++;
    },
    remove: function() {
      e--, !e && r && (r.parentNode && r.parentNode.removeChild(r), r = null);
    }
  };
}, _o = function() {
  var e = xo();
  return function(r, t) {
    O.useEffect(function() {
      return e.add(r), function() {
        e.remove();
      };
    }, [r && t]);
  };
}, Tr = function() {
  var e = _o(), r = function(t) {
    var n = t.styles, o = t.dynamic;
    return e(n, o), null;
  };
  return r;
}, Ro = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Qe = function(e) {
  return parseInt(e || "", 10) || 0;
}, Fo = function(e) {
  var r = window.getComputedStyle(document.body), t = r[e === "padding" ? "paddingLeft" : "marginLeft"], n = r[e === "padding" ? "paddingTop" : "marginTop"], o = r[e === "padding" ? "paddingRight" : "marginRight"];
  return [Qe(t), Qe(n), Qe(o)];
}, Ao = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Ro;
  var r = Fo(e), t = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: r[0],
    top: r[1],
    right: r[2],
    gap: Math.max(0, n - t + r[2] - r[0])
  };
}, Io = Tr(), ge = "data-scroll-locked", ko = function(e, r, t, n) {
  var o = e.left, a = e.top, u = e.right, i = e.gap;
  return t === void 0 && (t = "margin"), `
  .`.concat(Kt, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(i, "px ").concat(n, `;
  }
  body[`).concat(ge, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    r && "position: relative ".concat(n, ";"),
    t === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(u, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(n, `;
    `),
    t === "padding" && "padding-right: ".concat(i, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Me, ` {
    right: `).concat(i, "px ").concat(n, `;
  }
  
  .`).concat(Le, ` {
    margin-right: `).concat(i, "px ").concat(n, `;
  }
  
  .`).concat(Me, " .").concat(Me, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Le, " .").concat(Le, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(ge, `] {
    `).concat(Jt, ": ").concat(i, `px;
  }
`);
}, qr = function() {
  var e = parseInt(document.body.getAttribute(ge) || "0", 10);
  return isFinite(e) ? e : 0;
}, Mo = function() {
  O.useEffect(function() {
    return document.body.setAttribute(ge, (qr() + 1).toString()), function() {
      var e = qr() - 1;
      e <= 0 ? document.body.removeAttribute(ge) : document.body.setAttribute(ge, e.toString());
    };
  }, []);
}, Lo = function(e) {
  var r = e.noRelative, t = e.noImportant, n = e.gapMode, o = n === void 0 ? "margin" : n;
  Mo();
  var a = O.useMemo(function() {
    return Ao(o);
  }, [o]);
  return O.createElement(Io, { styles: ko(a, !r, o, t ? "" : "!important") });
}, ur = !1;
if (typeof window < "u")
  try {
    var Fe = Object.defineProperty({}, "passive", {
      get: function() {
        return ur = !0, !0;
      }
    });
    window.addEventListener("test", Fe, Fe), window.removeEventListener("test", Fe, Fe);
  } catch {
    ur = !1;
  }
var me = ur ? { passive: !1 } : !1, No = function(e) {
  return e.tagName === "TEXTAREA";
}, At = function(e, r) {
  if (!(e instanceof Element))
    return !1;
  var t = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    t[r] !== "hidden" && // contains scroll inside self
    !(t.overflowY === t.overflowX && !No(e) && t[r] === "visible")
  );
}, Do = function(e) {
  return At(e, "overflowY");
}, Wo = function(e) {
  return At(e, "overflowX");
}, Yr = function(e, r) {
  var t = r.ownerDocument, n = r;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = It(e, n);
    if (o) {
      var a = kt(e, n), u = a[1], i = a[2];
      if (u > i)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== t.body);
  return !1;
}, jo = function(e) {
  var r = e.scrollTop, t = e.scrollHeight, n = e.clientHeight;
  return [
    r,
    t,
    n
  ];
}, $o = function(e) {
  var r = e.scrollLeft, t = e.scrollWidth, n = e.clientWidth;
  return [
    r,
    t,
    n
  ];
}, It = function(e, r) {
  return e === "v" ? Do(r) : Wo(r);
}, kt = function(e, r) {
  return e === "v" ? jo(r) : $o(r);
}, Bo = function(e, r) {
  return e === "h" && r === "rtl" ? -1 : 1;
}, zo = function(e, r, t, n, o) {
  var a = Bo(e, window.getComputedStyle(r).direction), u = a * n, i = t.target, b = r.contains(i), d = !1, m = u > 0, s = 0, v = 0;
  do {
    var g = kt(e, i), S = g[0], c = g[1], y = g[2], p = c - y - a * S;
    (S || p) && It(e, i) && (s += p, v += S), i instanceof ShadowRoot ? i = i.host : i = i.parentNode;
  } while (
    // portaled content
    !b && i !== document.body || // self content
    b && (r.contains(i) || r === i)
  );
  return (m && Math.abs(s) < 1 || !m && Math.abs(v) < 1) && (d = !0), d;
}, Ae = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Ur = function(e) {
  return [e.deltaX, e.deltaY];
}, Vr = function(e) {
  return e && "current" in e ? e.current : e;
}, qo = function(e, r) {
  return e[0] === r[0] && e[1] === r[1];
}, Yo = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Uo = 0, he = [];
function Vo(e) {
  var r = O.useRef([]), t = O.useRef([0, 0]), n = O.useRef(), o = O.useState(Uo++)[0], a = O.useState(Tr)[0], u = O.useRef(e);
  O.useEffect(function() {
    u.current = e;
  }, [e]), O.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var c = Zt([e.lockRef.current], (e.shards || []).map(Vr), !0).filter(Boolean);
      return c.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), c.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = O.useCallback(function(c, y) {
    if ("touches" in c && c.touches.length === 2 || c.type === "wheel" && c.ctrlKey)
      return !u.current.allowPinchZoom;
    var p = Ae(c), C = t.current, w = "deltaX" in c ? c.deltaX : C[0] - p[0], T = "deltaY" in c ? c.deltaY : C[1] - p[1], f, W = c.target, j = Math.abs(w) > Math.abs(T) ? "h" : "v";
    if ("touches" in c && j === "h" && W.type === "range")
      return !1;
    var B = Yr(j, W);
    if (!B)
      return !0;
    if (B ? f = j : (f = j === "v" ? "h" : "v", B = Yr(j, W)), !B)
      return !1;
    if (!n.current && "changedTouches" in c && (w || T) && (n.current = f), !f)
      return !0;
    var G = n.current || f;
    return zo(G, y, c, G === "h" ? w : T);
  }, []), b = O.useCallback(function(c) {
    var y = c;
    if (!(!he.length || he[he.length - 1] !== a)) {
      var p = "deltaY" in y ? Ur(y) : Ae(y), C = r.current.filter(function(f) {
        return f.name === y.type && (f.target === y.target || y.target === f.shadowParent) && qo(f.delta, p);
      })[0];
      if (C && C.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!C) {
        var w = (u.current.shards || []).map(Vr).filter(Boolean).filter(function(f) {
          return f.contains(y.target);
        }), T = w.length > 0 ? i(y, w[0]) : !u.current.noIsolation;
        T && y.cancelable && y.preventDefault();
      }
    }
  }, []), d = O.useCallback(function(c, y, p, C) {
    var w = { name: c, delta: y, target: p, should: C, shadowParent: Ho(p) };
    r.current.push(w), setTimeout(function() {
      r.current = r.current.filter(function(T) {
        return T !== w;
      });
    }, 1);
  }, []), m = O.useCallback(function(c) {
    t.current = Ae(c), n.current = void 0;
  }, []), s = O.useCallback(function(c) {
    d(c.type, Ur(c), c.target, i(c, e.lockRef.current));
  }, []), v = O.useCallback(function(c) {
    d(c.type, Ae(c), c.target, i(c, e.lockRef.current));
  }, []);
  O.useEffect(function() {
    return he.push(a), e.setCallbacks({
      onScrollCapture: s,
      onWheelCapture: s,
      onTouchMoveCapture: v
    }), document.addEventListener("wheel", b, me), document.addEventListener("touchmove", b, me), document.addEventListener("touchstart", m, me), function() {
      he = he.filter(function(c) {
        return c !== a;
      }), document.removeEventListener("wheel", b, me), document.removeEventListener("touchmove", b, me), document.removeEventListener("touchstart", m, me);
    };
  }, []);
  var g = e.removeScrollBar, S = e.inert;
  return O.createElement(
    O.Fragment,
    null,
    S ? O.createElement(a, { styles: Yo(o) }) : null,
    g ? O.createElement(Lo, { gapMode: e.gapMode }) : null
  );
}
function Ho(e) {
  for (var r = null; e !== null; )
    e instanceof ShadowRoot && (r = e.host, e = e.host), e = e.parentNode;
  return r;
}
fr(Jr, Vo);
var Go = function(e) {
  if (typeof document > "u")
    return null;
  var r = Array.isArray(e) ? e[0] : e;
  return r.ownerDocument.body;
}, pe = /* @__PURE__ */ new WeakMap(), Ie = /* @__PURE__ */ new WeakMap(), ke = {}, er = 0, Mt = function(e) {
  return e && (e.host || Mt(e.parentNode));
}, Xo = function(e, r) {
  return r.map(function(t) {
    if (e.contains(t))
      return t;
    var n = Mt(t);
    return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(t) {
    return !!t;
  });
}, Zo = function(e, r, t, n) {
  var o = Xo(r, Array.isArray(e) ? e : [e]);
  ke[t] || (ke[t] = /* @__PURE__ */ new WeakMap());
  var a = ke[t], u = [], i = /* @__PURE__ */ new Set(), b = new Set(o), d = function(s) {
    !s || i.has(s) || (i.add(s), d(s.parentNode));
  };
  o.forEach(d);
  var m = function(s) {
    !s || b.has(s) || Array.prototype.forEach.call(s.children, function(v) {
      if (i.has(v))
        m(v);
      else
        try {
          var g = v.getAttribute(n), S = g !== null && g !== "false", c = (pe.get(v) || 0) + 1, y = (a.get(v) || 0) + 1;
          pe.set(v, c), a.set(v, y), u.push(v), c === 1 && S && Ie.set(v, !0), y === 1 && v.setAttribute(t, "true"), S || v.setAttribute(n, "true");
        } catch (p) {
          console.error("aria-hidden: cannot operate on ", v, p);
        }
    });
  };
  return m(r), i.clear(), er++, function() {
    u.forEach(function(s) {
      var v = pe.get(s) - 1, g = a.get(s) - 1;
      pe.set(s, v), a.set(s, g), v || (Ie.has(s) || s.removeAttribute(n), Ie.delete(s)), g || s.removeAttribute(t);
    }), er--, er || (pe = /* @__PURE__ */ new WeakMap(), pe = /* @__PURE__ */ new WeakMap(), Ie = /* @__PURE__ */ new WeakMap(), ke = {});
  };
}, Ko = function(e, r, t) {
  var n = Array.from(Array.isArray(e) ? e : [e]), o = r || Go(e);
  return o ? (n.push.apply(n, Array.from(o.querySelectorAll("[aria-live]"))), Zo(n, o, t, "aria-hidden")) : function() {
    return null;
  };
}, Jo = Tr(), Qo = `
 [` + ct + `] {
   pointer-events: none !important;
 }
`, ea = function() {
  return O.createElement(Jo, { styles: Qo });
}, Hr = function(e) {
  return "current" in e ? e.current : e;
};
function ra(e) {
  var r = e.setLockProps, t = e.onEscapeKey, n = e.onClickOutside, o = e.shards, a = e.onActivation, u = e.onDeactivation, i = e.noIsolation, b = we(void 0), d = b[0], m = b[1], s = Oe(null), v = Oe(0);
  return O.useEffect(function() {
    var g = function(p) {
      p.defaultPrevented || (p.code === "Escape" || p.key === "Escape" || p.keyCode === 27) && t && t(p);
    }, S = function(p) {
      p.defaultPrevented || p.target === s.current || p instanceof MouseEvent && p.button !== 0 || o && o.map(Hr).some(function(C) {
        return C && C.contains(p.target) || C === p.target;
      }) || n && n(p);
    }, c = function(p) {
      S(p), v.current = p.touches.length;
    }, y = function(p) {
      v.current = p.touches.length;
    };
    if (d)
      return document.addEventListener("keydown", g), document.addEventListener("mousedown", S), document.addEventListener("touchstart", c), document.addEventListener("touchend", y), function() {
        document.removeEventListener("keydown", g), document.removeEventListener("mousedown", S), document.removeEventListener("touchstart", c), document.removeEventListener("touchend", y);
      };
  }, [d, n, t]), Ne(function() {
    if (d)
      return a && a(d), function() {
        u && u();
      };
  }, [!!d]), Ne(function() {
    var g = function() {
      return null;
    }, S = !1, c = function(p) {
      i || (g = Ko(Xt([p], (o || []).map(Hr)), document.body, ct)), m(function() {
        return p;
      });
    }, y = function() {
      g(), S || m(null);
    };
    return r({
      onMouseDown: function(p) {
        s.current = p.target;
      },
      onTouchStart: function(p) {
        s.current = p.target;
      },
      onActivation: c,
      onDeactivation: y
    }), function() {
      S = !0, r(!1);
    };
  }, []), O.createElement(ea, null);
}
const ta = fr(ut, ra);
var na = function(e) {
  return O.createElement(ta, q({}, e));
}, oa = O.forwardRef(function(e, r) {
  return O.createElement(bn, q({}, e, { ref: r, sideCar: na }));
});
const aa = "common", ia = {
  closeButtonLabel: "Close"
}, ua = {
  namespace: aa,
  strings: ia
}, ca = "_overlay_1r9hh_1", sa = "_focus-container_1r9hh_14", fa = "_size-sm_1r9hh_31", la = "_size-md_1r9hh_38", da = "_size-lg_1r9hh_45", va = "_size-xl_1r9hh_50", ma = "_size-full_1r9hh_56", ha = "_page-width_1r9hh_61", pa = "_size-auto_1r9hh_66", ya = "_modal_1r9hh_71", ba = "_close-icon_1r9hh_80", H = {
  overlay: ca,
  focusContainer: sa,
  sizeSm: fa,
  sizeMd: la,
  sizeLg: da,
  sizeXl: va,
  sizeFull: ma,
  pageWidth: ha,
  sizeAuto: pa,
  modal: ya,
  closeIcon: ba
}, ga = {
  sm: H.sizeSm,
  md: H.sizeMd,
  lg: H.sizeLg,
  xl: H.sizeXl,
  full: H.sizeFull,
  auto: H.sizeAuto,
  pageWidth: H.pageWidth
};
function Aa(e) {
  const {
    closeOnClickOutside: r = !1,
    closeOnEscape: t = !1,
    onClose: n,
    overlayClassName: o,
    size: a = "md",
    withoutCloseButton: u = !1,
    className: i,
    headerActions: b,
    modalContainerClassName: d,
    ...m
  } = e, s = Ht(ua);
  Ne(
    () => {
      const c = document.documentElement.style.scrollbarGutter;
      return document.documentElement.style.scrollbarGutter = "initial", () => {
        document.documentElement.style.scrollbarGutter = c;
      };
    },
    []
  );
  const v = ga[a], g = ae(() => {
    r && n && n();
  }, [n, r]), S = ae(() => {
    t && n && n();
  }, [n, t]);
  return /* @__PURE__ */ ve(Vt, { children: /* @__PURE__ */ ve("div", { className: $e(H.overlay, o), children: /* @__PURE__ */ ve(
    oa,
    {
      className: $e(H.focusContainer, d, v),
      onClickOutside: g,
      onEscapeKey: S,
      gapMode: "padding",
      children: /* @__PURE__ */ ve(
        Ut,
        {
          ...m,
          withPadding: !0,
          withoutWrapInHeader: !0,
          withoutWrapInFooter: !0,
          className: $e(H.modal, i),
          withContentOverflow: !0,
          headerActions: !u || b ? /* @__PURE__ */ Nt(Dt, { children: [
            b,
            /* @__PURE__ */ ve(
              Yt,
              {
                name: void 0,
                onClick: n,
                styleVariant: "action",
                colorVariant: "text",
                title: s.closeButtonLabel,
                children: /* @__PURE__ */ ve(qt, { className: H.closeIcon })
              }
            )
          ] }) : void 0
        }
      )
    }
  ) }) });
}
export {
  Aa as default
};
